module.exports = __webpack_public_path__ + "img/bell-fill.d1a8ca6e.svg";